// @ts-check
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import QuestionnaireActions from 'agent_portal/actions/ReferralProfiles/QuestionnaireActions';
import { Row, Widget } from 'shared/containers/portal_layout';
import QuestionnaireForm from './QuestionnaireForm';

/** @typedef {{
  params: { referralProfileId: string },
  loaded: boolean,
  referralQuestionnaire?: any,
  patientName?: string,
  referralProfile?: any,
  rulableReferralProfileValues?: any
}} ReferralQuestionnairePagePropsType */

/** @augments { Component<ReferralQuestionnairePagePropsType, {}> } */
class ReferralQuestionnairePage extends Component {
  componentDidMount() {
    const { referralProfileId } = this.props.params;
    QuestionnaireActions.fetchQuestionnaire(referralProfileId);
  }

  saveQuestionnaire = questionnaireFormData => {
    const data = {
      questionnaire: questionnaireFormData.questionnaire,
      referral_profile: questionnaireFormData.referralProfile,
    };
    const { referralProfileId } = this.props.params;
    return QuestionnaireActions.submitReferralQuestionnaire(referralProfileId, data).then(
      response => {
        // TODO: This might be routing prior to AJAX finishing, which is unexpected.
        browserHistory.push(`/a/portal/referral_profiles/${referralProfileId}/referral_dashboard`);
        return null;
      }
    );
  };

  render() {
    const {
      loaded,
      referralQuestionnaire,
      patientName,
      referralProfile,
      rulableReferralProfileValues,
    } = this.props;

    return (
      <Row>
        <Widget
          title={`Please answer these questions for ${patientName}`}
          span={12}
          isLoading={!loaded}
          nopadding
        >
          {loaded ? (
            <QuestionnaireForm
              questionnaire={referralQuestionnaire}
              referralProfile={referralProfile}
              rulableReferralProfileValues={rulableReferralProfileValues}
              saveQuestionnaire={this.saveQuestionnaire}
            />
          ) : null}
        </Widget>
      </Row>
    );
  }
}

ReferralQuestionnairePage.propTypes = {
  params: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const {
    referralQuestionnaire,
    patientName,
    referralProfile,
    rulableReferralProfileValues,
  } = state.referralQuestionnaire;

  return {
    loaded: !!referralProfile,
    referralQuestionnaire,
    patientName,
    referralProfile,
    rulableReferralProfileValues,
  };
}

export default connect(mapStateToProps)(ReferralQuestionnairePage);
